import React from 'react';

interface AnimatedBlobProps {
  className?: string;
  variant?: 'default' | 'purple' | 'blue' | 'mixed';
}

const blobConfigs = {
  default: [
    { color: 'bg-purple-300 dark:bg-purple-500', position: 'top-0 -left-4', delay: '' },
    { color: 'bg-blue-300 dark:bg-blue-500', position: 'top-0 -right-4', delay: 'animation-delay-2000' },
    { color: 'bg-cyan-300 dark:bg-cyan-500', position: '-bottom-8 left-20', delay: 'animation-delay-4000' },
  ],
  purple: [
    { color: 'bg-purple-400 dark:bg-purple-600', position: 'top-10 left-10', delay: '' },
    { color: 'bg-violet-300 dark:bg-violet-500', position: 'top-20 right-20', delay: 'animation-delay-2000' },
    { color: 'bg-fuchsia-300 dark:bg-fuchsia-500', position: 'bottom-10 left-1/3', delay: 'animation-delay-4000' },
  ],
  blue: [
    { color: 'bg-blue-400 dark:bg-blue-600', position: 'top-0 left-1/4', delay: '' },
    { color: 'bg-sky-300 dark:bg-sky-500', position: 'top-1/3 -right-10', delay: 'animation-delay-2000' },
    { color: 'bg-indigo-300 dark:bg-indigo-500', position: 'bottom-0 left-10', delay: 'animation-delay-4000' },
  ],
  mixed: [
    { color: 'bg-primary-light/30 dark:bg-primary-dark/30', position: 'top-0 -left-4', delay: '' },
    { color: 'bg-secondary-light/30 dark:bg-secondary-dark/30', position: 'top-0 -right-4', delay: 'animation-delay-2000' },
    { color: 'bg-emerald-300/30 dark:bg-emerald-500/30', position: '-bottom-8 left-20', delay: 'animation-delay-4000' },
  ],
};

export const AnimatedBlob: React.FC<AnimatedBlobProps> = ({
  className = '',
  variant = 'default',
}) => {
  const blobs = blobConfigs[variant];

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {blobs.map((blob, index) => (
        <div
          key={index}
          className={`
            absolute w-72 h-72 rounded-full
            mix-blend-multiply dark:mix-blend-screen
            filter blur-xl opacity-70 dark:opacity-30
            animate-blob ${blob.delay}
            ${blob.color} ${blob.position}
          `}
        />
      ))}
    </div>
  );
};

export default AnimatedBlob;
